export default __webpack_public_path__ + "media/images/react_icons/swatchbook-e292171238b74d054ec01ada4532e1d8.svg";